/**
 * The two endings of a request the patient closed by choosing "I have
 * decided not to have this form filled out" (ruling 2026-10-14, no free
 * path, case imp_a6b6fd85; wording G20, 2026-10-15, case imp_e56c2f19):
 *
 *   FeeDeclinedNotice    the PATIENT's closing page (BridgeOnboardingPage
 *                        STAGE.DECLINED) and the status page's card: nothing
 *                        was charged and the signing physician's office has
 *                        been told, with the office's own number when the
 *                        row carries one. No paper form, no printing. The
 *                        wording is `declinedCopy` (lib/paymentDisplay).
 *   RequestClosedNotice  every OTHER signer (the plan member) of that
 *                        request: "This request was closed. Nothing more is
 *                        needed from you." It never says why: the payment
 *                        choice is the patient's alone.
 *
 * Neither offers the prepared PDF (that is Parseo's work, not handed over
 * once the patient declined), the questionnaire or the PA tracker.
 * All copy is a DRAFT for Michael's approval before live.
 * React-17 safe: inline styles, no new dependencies.
 */
import React from "react";

import {
  REQUEST_CLOSED_BODY,
  REQUEST_CLOSED_HEADING,
  declinedCopy,
} from "../../lib/paymentDisplay";
import type { PatientPaymentStatus } from "../../types/shared";

const INK = "#182a33";
const BODY = "#5b6e7c";

export function FeeDeclinedNotice({
  payment,
  compact = false,
}: {
  payment: PatientPaymentStatus | null;
  /** Inside the status page's card: a smaller heading, left-aligned. */
  compact?: boolean;
}) {
  const c = declinedCopy(payment);
  return (
    <div data-testid="fee-declined" style={{ maxWidth: 440, textAlign: compact ? "left" : "center" }}>
      <h2
        data-testid="fee-declined-heading"
        style={{ color: INK, margin: compact ? "0 0 6px" : "16px 0 6px", fontSize: compact ? 16 : undefined }}
      >
        {c.heading}
      </h2>
      <p data-testid="fee-declined-body" style={{ color: BODY, lineHeight: 1.5, margin: 0, fontSize: compact ? 13.5 : undefined }}>
        {c.body}
      </p>
      {c.phone ? (
        <p data-testid="fee-declined-phone" style={{ color: BODY, lineHeight: 1.5, margin: "10px 0 0", fontSize: compact ? 13.5 : undefined }}>
          {c.office}: <a href={c.phone.href}>{c.phone.value}</a>
        </p>
      ) : null}
    </div>
  );
}

export function RequestClosedNotice({ compact = false }: { compact?: boolean }) {
  return (
    <div data-testid="request-closed" style={{ maxWidth: 440, textAlign: compact ? "left" : "center" }}>
      <h2 style={{ color: INK, margin: compact ? "0 0 6px" : "16px 0 6px", fontSize: compact ? 16 : undefined }}>
        {REQUEST_CLOSED_HEADING}
      </h2>
      <p style={{ color: BODY, lineHeight: 1.5, margin: 0, fontSize: compact ? 13.5 : undefined }}>
        {REQUEST_CLOSED_BODY}
      </p>
    </div>
  );
}
